// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/Homepage';
import CCTVPlayerPage from './pages/CCTVPlayerPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:gps" element={<CCTVPlayerPage />} />
      </Routes>
    </Router>
  );
}

export default App;
